import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { EntryLayout } from "../components/entryLayout";
import axios from "axios";

function Register() {
  let [searchParams] = useSearchParams();
  const [companies, setCompanies] = React.useState([]);
  const [company, setCompany] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const baseURL = process.env.REACT_APP_API_BASE_URL || "";
  const slug_name = searchParams.get('slug_name')

  React.useEffect(() => {
    let url = `${baseURL}/api/v1/companies/`
    if(slug_name){
      url += `?slug_name=${slug_name}`
    }
    async function fetchData() {
      try {
        let res = await axios.get(url);
        try {
          let json = await res.data;
          // DRF returns a paginated envelope {count, results}; fall back to the
          // raw payload if pagination is ever disabled.
          setCompanies(json.results ?? json);
        } catch (error) {
          console.log(error);
          let json = res.response.data;
          console.log(json.detail);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
    // Intentionally run once on mount only — baseURL is a static env value and
    // re-fetching on every slug_name identity change (searchParams is a new
    // object per navigation) is not desired here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let url = `${baseURL}/api/v1/auth/users/`;
    try {
      let payload = { username, password, email, company };
      const response = await axios.post(url, payload);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <EntryLayout>
      <h4>New here?</h4>
      <h6 className="font-weight-light">
        Join us today! It takes only few steps
      </h6>
      <form className="pt-3" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Username</label>
          <div className="input-group">
            <div className="input-group-prepend bg-transparent">
              <span className="input-group-text bg-transparent border-right-0">
                <i className="mdi mdi-account-outline text-primary"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control form-control-lg border-left-0"
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Email</label>
          <div className="input-group">
            <div className="input-group-prepend bg-transparent">
              <span className="input-group-text bg-transparent border-right-0">
                <i className="mdi mdi-email-outline text-primary"></i>
              </span>
            </div>
            <input
              type="email"
              className="form-control form-control-lg border-left-0"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Academy</label>
          <select
            className="form-control form-control-lg"
            id="exampleFormControlSelect2"
            onChange={(e) => setCompany(e.target.value)}
          >
            {companies.length > 1 && <option>-- Select --</option>}
            {companies.map((company) => {
              return (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="form-group">
          <label>Password</label>
          <div className="input-group">
            <div className="input-group-prepend bg-transparent">
              <span className="input-group-text bg-transparent border-right-0">
                <i className="mdi mdi-lock-outline text-primary"></i>
              </span>
            </div>
            <input
              type="password"
              className="form-control form-control-lg border-left-0"
              id="exampleInputPassword"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>
        <div className="mb-4">
          <div className="form-check">
            <label className="form-check-label text-muted">
              <input type="checkbox" className="form-check-input" />I agree to
              all Terms & Conditions
            </label>
          </div>
        </div>
        <div className="mt-3">
          <button
            type="submit"
            className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
          >
            SIGN UP
          </button>
        </div>
        <div className="text-center mt-4 font-weight-light">
          Already have an account?{" "}
          <Link to="/login" className="text-primary">
            Login
          </Link>
        </div>
      </form>
    </EntryLayout>
  );
}

export { Register };
